/**
 * Wallet style catalog + platform derivation — the single source of
 * truth for the per-platform style dropdowns (§4/§8 of the wallet
 * style-selector design). Kept React-free so it can be unit-tested
 * in the node-env vitest the frontend package ships with.
 */

export type AppleStyle = 'boardingPass' | 'coupon' | 'eventTicket' | 'generic' | 'storeCard';
export type GoogleStyle = 'flight' | 'offer' | 'eventTicket' | 'generic' | 'loyalty';

export interface StyleOption<T extends string> {
  value: T;
  label: string;
}

export const APPLE_STYLES: ReadonlyArray<StyleOption<AppleStyle>> = [
  { value: 'boardingPass', label: 'Boarding pass (járat)' },
  { value: 'coupon', label: 'Coupon (kupon / voucher)' },
  { value: 'eventTicket', label: 'Event ticket (belépő)' },
  { value: 'generic', label: 'Generic (általános kártya)' },
  { value: 'storeCard', label: 'Store card (egyenleg / loyalty)' },
];

export const GOOGLE_STYLES: ReadonlyArray<StyleOption<GoogleStyle>> = [
  { value: 'flight', label: 'Flight (járat)' },
  { value: 'offer', label: 'Offer (kupon / voucher)' },
  { value: 'eventTicket', label: 'Event ticket (belépő)' },
  { value: 'generic', label: 'Generic (általános kártya)' },
  { value: 'loyalty', label: 'Loyalty (egyenleg / tagság)' },
];
